import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import TeleconnectSalesChart from './graphs/TeleconnectSalesChart';
import '../../App.css';
import getTeleconnectSales from '../../services/getTeleconnectSales';
import TeleconnectSearchBar from './TeleconnectSearchBar';

const TeleconnectSales = (props) => {

  const t = props.t;
  const i18n = props.i18n;
  const [teleconnectSales, setTeleconnectSales] = useState([])
  const [companySelected, setCompanySelected] = useState(0)
  const [resellerSelected, setResellerSelected] = useState(0)

  useEffect(() => {
    getTeleconnectSales(props.loginParameters.accesToken, companySelected, resellerSelected)
      .then(teleconnectSales => setTeleconnectSales(teleconnectSales))
  }, [props.loginParameters.accesToken, companySelected, resellerSelected])

  return (
    <Container id="main-container">
      <TeleconnectSearchBar
        t={t}
        accesToken={props.loginParameters.accesToken}
        setCompanySelected={setCompanySelected}
        setResellerSelected={setResellerSelected}
      />
      <h2 style={{ padding: 20 }} > Ventas de Teleconnect</h2>
      <Tabs
        defaultActiveKey="daily"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="daily" title={t('daily')}>
          <TeleconnectSalesChart
            data={teleconnectSales.dataByDay}
            xlabel='date'
            t={t}
            i18n={i18n}
            type={'daily'}
          />
        </Tab>
        <Tab eventKey="weekly" title={t('weekly')}>
          <TeleconnectSalesChart
            data={teleconnectSales.dataByWeek}
            xlabel='week'
            t={t}
            i18n={i18n}
            type={'weekly'}
          />
        </Tab>
        <Tab eventKey="monthly" title={t('monthly')}>
          <TeleconnectSalesChart
            data={teleconnectSales.dataByMonth}
            xlabel='month'
            t={t}
            i18n={i18n}
            type={'monthly'}
          />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default TeleconnectSales;